// src/stores/workflowStagesStore.js
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { collection, query, orderBy } from 'firebase/firestore'
import { onSnapshot } from '@/services/sessionListeners'
import { db } from '@/services/firebaseconfig'

export const useWorkflowStagesStore = defineStore('workflowStages', () => {
  const allStages = ref([])
  const isLoading = ref(false)
  const hasFetched = ref(false)
  let _unsubscribe = null

  // Phase 33B: Real-time subscription
  function subscribe(options = {}) {
    const force = options.force === true
    if (force && _unsubscribe) {
      _unsubscribe()
      _unsubscribe = null
      hasFetched.value = false
    }
    if (_unsubscribe) return
    isLoading.value = true
    const perfLabel = `[PERF] [workflowStagesStore] subscribe`
    console.time(perfLabel)
    _unsubscribe = onSnapshot(
      query(collection(db, 'workflowStages'), orderBy('displayName')),
      snap => {
        allStages.value = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))
        if (!hasFetched.value) console.timeEnd(perfLabel)
        hasFetched.value = true
        isLoading.value = false
      },
      error => {
        console.error('[workflowStagesStore] onSnapshot error:', error)
        isLoading.value = false
      }
    )
  }

  function unsubscribeAll() {
    if (_unsubscribe) {
      _unsubscribe()
      _unsubscribe = null
    }
    hasFetched.value = false
    allStages.value = []
  }

  // Backward-compatible alias
  function fetchStages(options = {}) {
    subscribe(options)
  }

  const stageMap = computed(() => {
    const map = {}
    for (const s of allStages.value) {
      map[s.id] = s
    }
    return map
  })

  function getStageById(stageId) {
    return stageMap.value[stageId] || null
  }

  return {
    allStages,
    isLoading,
    hasFetched,
    fetchStages,
    subscribe,
    unsubscribeAll,
    stageMap,
    getStageById,
  }
})
